<script lang="ts">
  import { _ } from 'svelte-i18n';
  import TableJobs from '../../components/Contents/Jobs/TableJobs.svelte';
  import TableRoles from '../../components/Contents/Roles/TableRoles.svelte';
</script>

<TableRoles title={$_('role.title')} />
